import { AbstractHttp } from '@app/libs/services';
import { HttpError } from '@app/libs/services/BaseService';

export abstract class BaseClientService extends AbstractHttp {
  public async send(action: string, options: any): Promise<any> {
    try {
      const response = await super.send(action, options);

      if (response.success === false && response.errors.error === 'UNAUTHORIZED') {
        (window as any).logout(true);

        return {};
      }

      return response;
    } catch (exception: any) {
      if (exception.status === 401) {
        (window as any).logout(true);
      }

      return Promise.reject(exception);
    }
  }
}
